// Extract var_ parameters from URL
export const getVarsFromSearchParams = (
  searchParams: URLSearchParams
): Record<string, string | number | boolean> => {
  const variables: Record<string, string | number | boolean> = {}
  searchParams.forEach((value: string, key: string) => {
    if (key.startsWith('var_')) {
      let parsedValue: string | number | boolean = value
      if (value === 'true') {
        parsedValue = true
      } else if (value === 'false') {
        parsedValue = false
      } else if (!isNaN(Number(value)) && value.trim() !== '') {
        parsedValue = Number(value)
      }
      variables[key.replace('var_', '')] = parsedValue
    }
  })
  return variables
}
